import Image from 'next/image'
import { useTranslation } from 'next-i18next'
import { Dialog } from '@captaincause/ui/Modals/Dialog'
import PrivateProjectModal from 'assets/private-project-modal.webp'
import { Button } from 'components/Button'
import type { Dispatch, SetStateAction } from 'react'

interface ModalProps {
  isOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
}

export function Modal({ isOpen, setIsOpen }: ModalProps) {
  const { t } = useTranslation('projects.page')

  return (
    <Dialog
      isOpen={isOpen}
      close={() => {
        setIsOpen(false)
      }}
      containerClassName="text-left mx-auto max-w-xl"
      panelClassName="max-w-[480px] p-6 flex flex-col gap-6"
      rootNode="__next"
    >
      <Image
        src={PrivateProjectModal}
        alt="Add your private project"
        width={432}
        height={316}
      />

      <div>
        <h2 className="mb-2 text-center font-default text-lg font-semibold leading-7">
          {t('private-project.modal.title')}
        </h2>
        <p className="text-center text-sm font-normal leading-[22px] text-dark-gray">
          {t('private-project.modal.description')}
        </p>
      </div>

      <div className="flex flex-col items-center space-y-4 lg:flex-row lg:space-x-4 lg:space-y-0">
        <Button variant="secondary" onClick={() => setIsOpen(false)} full>
          {t('private-project.modal.exit')}
        </Button>

        <Button variant="primary" href="/contact" full>
          {t('private-project.modal.cta')}
        </Button>
      </div>
    </Dialog>
  )
}
